import inlineNotificationTemplate from '../templates/inlineNotification.hbs';
import $ from 'jquery';

$.fn.sdaInlineNotification = function(msg) {
    const that = this;
    const $in = $(inlineNotificationTemplate(msg));
    const offsetLeft = that.offset().left + that.textWidth() + 10;

    that.after($in);
    that.next().css({left: offsetLeft});
    setTimeout(function() {
        that.next().remove();
    }, 3000);

    return that;
};

// retuns the width in pixels of the text of an element
$.fn.textWidth = function(text, font) {
    if (!$.fn.textWidth.fakeEl) {
        $.fn.textWidth.fakeEl = $('<span>')
            .hide()
            .appendTo(document.body);
    }

    $.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css('font', font || this.css('font'));

    return $.fn.textWidth.fakeEl.width();
};
